

















































































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import { FilteringSortingTableStore } from "@/mixins/tableWithFilteringAndSortingStore";
import { IFilter, ISorter } from "@/models/tables";
import { DataModules } from "@/store/modules/data";
import { FilterOperators, FilterTypes } from "@/data/table";
import { IClient } from "@/models/clients";
import Context from "@/mixins/context";
import { mapGetters } from "vuex";
import AdminBrands from "@/mixins/adminBrands";

@Component({
  components: {
    "basket-items-summary": () =>
      import("@/components/app/global/orders/orderItemsSummary.vue")
  },
  computed: {
    ...mapGetters({
      isMultibrand: "brand/isMultibrand"
    })
  }
})
export default class BasketsTable extends Mixins(
  Context,
  AdminBrands,
  FilteringSortingTableStore
) {
  @Prop({ required: false, default: null })
  public clientId!: IClient["id"];

  public dataModule: DataModules = DataModules.BASKETS;
  public isMultibrand!: boolean;

  public filters: IFilter[] = [
    {
      key: "created_at",
      label: this.$t("_.created"),
      type: FilterTypes.DATE,
      operator: FilterOperators.EQUAL
    },
    {
      key: "updated_at",
      label: this.$t("_.updated"),
      type: FilterTypes.DATE,
      operator: FilterOperators.EQUAL
    }
  ];

  public sorters: ISorter[] = [
    {
      field: "created_at",
      label: this.$t("_.created")
    },
    {
      field: "updated_at",
      label: this.$t("_.updated")
    }
  ];
  public loading = true;

  public created() {
    this.apiProps = {
      with: [
        "client",
        "client.image",
        "address",
        "company",
        "category",
        "products"
      ].join()
    };
    this.getData();
  }

  // overrides mixin method
  public getStoreParams(params: any): Promise<any> {
    return this.$_.merge(params, {
      params: {
        ...params.filter,
        ...(this.clientId ? { "filter[client_id]": this.clientId } : {})
      }
    });
  }
}
